import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a34b945"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_title" }, " 참여하신 조합이 있습니다. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, [
  /*#__PURE__*/_createTextVNode(" 조합의 안전한 유지 및 관리를 위해"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 조합원은 서비스 탈퇴가 불가능합니다 🙏 ")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 참여조합 ")
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_8 = { class: "group_name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab_16M" }, "확인", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "content_wrap" }
const _hoisted_12 = { class: "main_content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_title" }, " 탈퇴 안내 ", -1))
const _hoisted_14 = { class: "info_list" }
const _hoisted_15 = { class: "main_bottom" }
const _hoisted_16 = { class: "btns" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab_16M" }, "취소", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab_16M" }, "탈퇴하기", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_buttons, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                "default-href": "/settings",
                icon: _ctx.chevronBack
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ag_box, {
              dp: "flex",
              direction: "column",
              height: "100%",
              pb: "safeAreaBottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  shrink: "0",
                  grow: "0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  shrink: "0",
                  grow: "0",
                  class: "group_title"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  shrink: "0",
                  grow: "1",
                  "min-height": "0",
                  height: "0",
                  mb: "20px",
                  "overflow-y": "auto"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        class: "group_list"
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            alt: "company-icon",
                            class: "img-circle img-responsive",
                            src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png' ,
                            onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.src='/assets/icon/company_default_img.png'))
                          }, null, 40, _hoisted_6),
                          _hoisted_7
                        ]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item.partnershipName), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  shrink: "0",
                  grow: "0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "blue_btn",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/settings'))
                    }, _hoisted_10)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, !_ctx.isAvailable]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdrawalInfoList, (l) => {
                  return (_openBlock(), _createElementBlock("li", { key: l }, _toDisplayString(l), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "white_btn",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.router.push('/settings'))
                }, _hoisted_18),
                _createElementVNode("button", {
                  class: "blue_btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createModal('survey')))
                }, _hoisted_20)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isAvailable]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}